import { render, staticRenderFns } from "./compact-list.vue?vue&type=template&id=5f6a7c81&scoped=true&"
import script from "./compact-list.vue?vue&type=script&lang=js&"
export * from "./compact-list.vue?vue&type=script&lang=js&"
import style0 from "./compact-list.vue?vue&type=style&index=0&id=5f6a7c81&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a7c81",
  null
  
)

export default component.exports